import SnippetPopoverEmptyState from './SnippetPopoverEmptyState';
import SnippetPopoverContentResults from './SnippetPopoverContentResults';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SnippetPopoverBodyBase({
  snippets,
  onInsert,
  setQueryInput,
  setSearched,
  searched
}) {
  const hasSnippets = !!snippets.length;
  return /*#__PURE__*/_jsx("div", {
    children: !searched && !hasSnippets ? /*#__PURE__*/_jsx(SnippetPopoverEmptyState, {}) : /*#__PURE__*/_jsx(SnippetPopoverContentResults, {
      setQueryInput: setQueryInput,
      snippets: snippets,
      onSelect: onInsert,
      setSearched: setSearched
    })
  });
}